/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { AuthenticationType } from "src/types/repository.type";

export class AuthRepository {
  
  static setAuthentication(data: any, token:string) {
    let authenticationData:AuthenticationType = {};
    authenticationData.accessToken = `Bearer ${token}` || '';
    authenticationData.refreshToken = `Bearer ${token}` || '';
    authenticationData.userAccount = {
      defaultName: data?.idTokenClaims?.name || '',
      name: data?.idTokenClaims?.given_name || '',
      lastName: data?.idTokenClaims?.family_name || '',
      secondLastName: data?.idTokenClaims?.extension_family_second_name || '',
      email: data?.idTokenClaims?.email || '',
      licenseCode: data?.idTokenClaims?.extension_LicenseCode || '',
      licenseId: data?.idTokenClaims?.extension_LicenseID || '',
    }
    return authenticationData;
  }
  
}
